import { Box, Flex } from '@chakra-ui/react';
import { useFocus } from '../Focus';
import { ReactElement, ReactNode } from 'react';

export interface PageTransformContainerProps {
  children: ReactNode;
  readonly?: boolean;
}

export const PageTransformContainer = ({ children, readonly = false }: PageTransformContainerProps): ReactElement => {
  const { pageFocusWrapperRef } = useFocus();

  return (
    <Box minH='100%' minW='100%' display='flex' position='absolute' pointerEvents={readonly ? 'none' : 'auto'}>
      <Flex position='relative' transform='scale(1)' flex='1'>
        <Flex position='relative' m='auto' shrink={0} justify='center'>
          <Flex p='24px' direction='column' position='relative' ref={readonly ? undefined : pageFocusWrapperRef}>
            {children}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};
